const pointConfig = {
    point: {
        filterLayout: 'PointFilterDefaultLayout',
        listLayout: 'PointListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
            code: 'all',
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getPointList',
        isCategory: false,
    },
    storePoint: {
        filterLayout: 'PointFilterStoreLayout',
        listLayout: 'PointListStoreLayout',
        paginationLayout: 'PaginationDefaultLayout',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getStorePoint',
        isCategory: false,
    }
}

export default {
    methods: {
        returnPointConfig(type) {
            return pointConfig[type];
        },
    },
    filterConfig: {
        cr: { // 작성일
            type: 'between',
            classname: 'filterDate',
        },
        ni: { // 신청자 닉네임
            type: 'query',
            classname: 'searchInput',
        },
        mid: { // 신청자 아이디
            type: 'query',
            classname: 'searchInput',
        },
        em: { // 인증 메일 주소
            type: 'query',
            classname: 'searchInput',
        },
        iste: { // 등급
            type: 'match',
            classname: 'filterGrade',
        },
        sid : { // 스토어
            type: 'match',
            classname: 'filterStore',
        },
        tab: {
            type: 'noFilter',
            classname: 'tab',
        },
    },
}
